import axios from "axios";
export async function get(assessment_id: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/impact/assessment/"+assessment_id);
    return response.data;
}

export async function update(assessment_id: string, data: FormData) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/impact/assessment/"+assessment_id+"/store",data);
    return response.data;
}